import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "35",
  height: "35",
  fill: "none",
  viewBox: "0 0 35 35"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#333",
      d: "M9.822 5.25A4.57 4.57 0 0 0 5.25 9.822v3.228a1.203 1.203 0 1 0 2.406 0V9.822a2.166 2.166 0 0 1 2.166-2.166h3.228a1.203 1.203 0 1 0 0-2.406zm12.653 0a1.203 1.203 0 1 0 0 2.406h3.228a2.166 2.166 0 0 1 2.166 2.166v3.228a1.203 1.203 0 1 0 2.406 0V9.822a4.57 4.57 0 0 0-4.572-4.572zM7.656 22.475a1.203 1.203 0 1 0-2.406 0v3.228a4.57 4.57 0 0 0 4.572 4.572h3.228a1.203 1.203 0 0 0 0-2.406H9.822a2.166 2.166 0 0 1-2.166-2.166zm22.619 0a1.203 1.203 0 0 0-2.406 0v3.228a2.166 2.166 0 0 1-2.166 2.166h-3.228a1.203 1.203 0 1 0 0 2.406h3.228a4.57 4.57 0 0 0 4.572-4.572zm-18.769-5.916a1.203 1.203 0 1 0 0 2.407H24.02a1.203 1.203 0 1 0 0-2.407z"
    }, null, -1)
  ])))
}
export default { render: render }